import config from '@vyce/core/src/api/config';

import { HelpAndContact } from '.';

export const WorkerHelp = () => {
  return <HelpAndContact faqUrl={config.workerFaqUrl} />;
};
